module.exports = __webpack_public_path__ + "static/media/quote-icon.2f8bcf5d.svg";